import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    themes: {
      light: {
        primary: "#1E97FF",
        secondary: "#353a48",
        tertiary: "#889db0",
        "primary--dark": "#e1eafb",
        "primary--light": "#ecf3fd",
        success: "#00de71"
      }
    }
  }
});
